export const environment = {
  production: false,
  test: false,
  dev: true,
  baseUrl: 'https://dev-api.sales.hansons.com/gbb/api/v2',
};

